export default function Fun() {
    return (<div>
        I love you! :)
    </div>);
}